exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-cd91f5a2] .el-input--mini .el-input__inner {\n  font-size: 14px;\n  font-family: Roboto, serif;\n  height: 15px;\n  line-height: 28px;\n  border: none;\n  padding-left: 0;\n  color: #3a3ace;\n}\nh2[data-v-cd91f5a2] {\n  padding-bottom: 10px;\n  margin-top: 0;\n}\n.block[data-v-cd91f5a2] .el-input__inner {\n  border: 1px solid #F56C6C;\n  border-radius: 4px;\n}\n.message-err[data-v-cd91f5a2] {\n  color: #F56C6C;\n  margin-top: 6px;\n  font-size: 13px;\n}\n", ""]);

// exports
